var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"verdict_box",on:{"click":function($event){return _vm.$utils.ossOpen(_vm.verdict)}}},[_vm._v(" "+_vm._s(_vm.$utils.nameRender(_vm.verdict))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }